// Keep the action bar ("Abbrechen / Löschen / Übernehmen") in the thumb zone, above the on-screen
// keyboard, on the transfer-item editor (a cover on edit, a full-size modal on add).
//
// The overlay's scroll viewport does NOT shrink when the keyboard opens — only window.visualViewport
// does — so a bottom-pinned bar would sit *behind* the keyboard. Unpoly's overlay boxes carry no
// transform/filter (see unpoly.css), so `position: fixed` is viewport-relative here: we fix the
// footer to the bottom of the layout viewport and translate it up by the keyboard's height
// (innerHeight − visualViewport.height − offsetTop) whenever the visual viewport changes.
//
// Only the footer is pinned (not the whole screen) so the overlay's own top-right dismiss control
// stays clickable. Fixed positioning is gated behind the `is-keyboard-aware` class this compiler
// adds, so without JS the footer falls back to its sticky-bottom styling.
up.compiler('.transfer-item-edit', (root) => {
  const footer = root.querySelector('.transfer-item-edit__footer');
  const body = root.querySelector('.transfer-item-edit__body');
  if (!footer) { return; }

  const vv = window.visualViewport;
  root.classList.add('is-keyboard-aware');

  // The footer is now out of flow; pad the body so its last content can scroll clear of it.
  if (body) { body.style.paddingBottom = `${footer.offsetHeight}px`; }

  const applyOffset = () => {
    const keyboard = vv ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0;
    footer.style.transform = keyboard > 0 ? `translateY(-${keyboard}px)` : '';
  };
  applyOffset();

  if (vv) {
    vv.addEventListener('resize', applyOffset);
    vv.addEventListener('scroll', applyOffset);
  }
  window.addEventListener('orientationchange', applyOffset);

  return () => {
    if (vv) {
      vv.removeEventListener('resize', applyOffset);
      vv.removeEventListener('scroll', applyOffset);
    }
    window.removeEventListener('orientationchange', applyOffset);
    footer.style.transform = '';
    if (body) { body.style.paddingBottom = ''; }
    root.classList.remove('is-keyboard-aware');
  };
});
